import Vue from 'vue'
import moment from 'moment'
import router from '../../router'
import { lotteryPromotions } from '@/lotteryUserData'

export const promotions = {
    state: {
        status: 'idle',
        promotions: null,
        promotionsForFilters: [],
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 25,
            totalRecords: null
        },
        subscriptionsSearchQuery: '',
        promotionsSearchQuery: '',
        selectAll: false,
        selectedPromotions: [],
        perPageByRoute: {
            'promo-list': 25,
            'promo-yours': 25,
            'promo-later': 25,
            'promo-finished': 25
        },
        sortOptions: [
            {
                query: 'start_at',
                label: 'Data startu promocji'
            },
            {
                query: 'end_at',
                label: 'Data końca promocji'
            },
            {
                query: 'company',
                label: 'Organizator'
            },
            {
                query: 'type',
                label: 'Typ promocji'
            },
            {
                query: 'published_at',
                label: 'Ostatnio dodane'
            },
            {
                query: 'favourites.created_at',
                label: 'Ostatnio zapisane'
            },
            {
                query: 'subscriptions.status_updated_at',
                label: 'Ostatnio aktywowane'
            },
            {
                query: 'finished_at',
                label: 'Ostatnio zakończone'
            }
        ],
        activeSortOptionByRoute: {
            'promo-list': {
                query: 'published_at',
                label: 'Ostatnio dodane',
                direction: 'desc'
            },
            'promo-yours': {
                query: 'subscriptions.status_updated_at',
                label: 'Ostatnio aktywowane',
                direction: 'desc'
            },
            'promo-later': {
                query: 'start_at',
                label: 'Data startu promocji',
                direction: 'desc'
            },
            'promo-finished': {
                query: 'finished_at',
                label: 'Ostatnio zakończone',
                direction: 'desc'
            }
        },
        sort: {
            by: 'start_at',
            direction: 'desc'
        },
        promotionsIncludes:
            // eslint-disable-next-line max-len
            'company,products,logo,company.logo,product.dict_product,product_sets,product_set.product_set_dict_products,product_set_dict_product.dict_product,dict_product.image,product_set_dict_product.image',
        filters: {
            newPromos: {
                type: 'ui-checkbox-input',
                key: '',
                value: false,
                text: 'nowe promocje',
                tooltip:
                    'Promocje, które zostały udostępnione od Twojej ostatniej wizyty w Panelu',
                groupName: 'newPromos',
                groupTitle: 'Promocje',
                notToSend: true
            },
            'promo|subscriptions_auto_acceptance': {
                type: 'ui-checkbox-input',
                value: false,
                text: 'aktywowane przez centralę',
                groupName: 'newPromos',
                notToSend: false
            },
            activePromos: {
                type: 'ui-checkbox-input',
                key: '',
                value: false,
                text: 'już trwające',
                groupName: 'promoCheckboxes',
                groupTitle: 'Czas trwania',
                notToSend: true
            },
            endingPromos: {
                type: 'ui-checkbox-input',
                value: false,
                text: 'kończące się w ciągu 7 dni',
                groupName: 'promoCheckboxes',
                notToSend: true
            },
            startingPromos: {
                type: 'ui-checkbox-input',
                value: false,
                text: 'rozpoczynające się w ciągu 7 dni',
                groupName: 'promoCheckboxes',
                notToSend: true
            },
            'promo|query': {
                type: 'search-input',
                value: '',
                searchParamsTooltip: ['nazwie grupy', 'nazwie promocji', 'ID promocji', 'nazwie produktu', 'kodzie EAN']
            },
            'promo|company_id': {
                type: 'checkboxes',
                value: [],
                getter: 'getCompaniesForPromoFilters',
                text: 'Organizator',
                firstOption: 'Wszyscy',
                expectedType: 'string'
            },
            'promo|type': {
                type: 'checkboxes',
                value: [],
                getter: 'getPromoTypesForPromoFilters',
                text: 'Typy promocji',
                firstOption: 'Wszystkie',
                expectedType: 'string'
            },
            'promo|subscription|merchant|nip': {
                type: 'checkboxes',
                value: [],
                getter: 'getUserCompaniesForSelect',
                text: 'Moje firmy',
                firstOption: 'Wszystkie',
                expectedType: 'string',
                disabledLinkGenerator: true,
                additionalText: 'Firma'
            },
            'promo|subscription|merchant_id': {
                type: 'checkboxes',
                value: [],
                getter: 'getPromoMerchantsForSelect',
                text: 'Sklepy',
                firstOption: 'Wszystkie',
                expectedType: 'string',
                disabledLinkGenerator: true
            },
            userFilters: {
                type: 'user-filters'
            }
        },
        companiesForPromoFilters: [],
        promoTypesForPromoFilters: [],
        scrollY: null,
        acceptedPromotions: null,
        validationPricesError: false
    },
    mutations: {
        SET_PROMOTIONS_STATUS(state, status) {
            state.status = status
        },
        SET_PROMOTIONS(state, promotions) {
            state.promotions = promotions
        },
        SET_PROMOTIONS_FOR_FILTERS(state, promotions) {
            state.promotionsForFilters = promotions
        },
        SET_PROMOTIONS_PAGINATION(state, payload) {
            state.pagination = payload
        },
        SET_PROMOTIONS_PAGINATION_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SET_PROMOTIONS_PER_PAGE_BY_ROUTE(state, payload) {
            state.perPageByRoute = payload
        },
        SET_PROMOTIONS_PER_PAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_SELECTED_PROMOTIONS(state, payload) {
            state.selectedPromotions = payload
        },
        SET_SELECT_ALL_PROMOTIONS(state, payload) {
            state.selectAll = payload
        },
        SET_PROMOTIONS_SORT(state, payload) {
            state.sort = payload
        },
        SET_ACTIVE_SORT_OPTION_BY_ROUTE(state, { routeName, sortOption }) {
            if (state.activeSortOptionByRoute) {
                const tmpSortOptionsByRoute = Object.assign(
                    {},
                    state.activeSortOptionByRoute
                )

                if (tmpSortOptionsByRoute[routeName]) {
                    tmpSortOptionsByRoute[routeName] = Object.assign(
                        tmpSortOptionsByRoute[routeName],
                        sortOption
                    )
                }

                state.activeSortOptionByRoute = tmpSortOptionsByRoute
            }
        },
        SET_PROMOTIONS_SEARCH_QUERY(state, payload) {
            state.promotionsSearchQuery = payload
        },
        SET_SUBSCRIPTIONS_SEARCH_QUERY(state, payload) {
            state.subscriptionsSearchQuery = payload
        },
        SET_PROMOTIONS_INCLUDES(state, payload) {
            state.promotionsIncludes = payload
        },
        SET_SCROLLY(state, payload) {
            state.scrollY = payload
        },
        SET_PROMOTIONS_FILTER(state, { filter, value }) {
            Vue.set(state.filters[filter], 'value', value)
        },
        RESET_PROMOTIONS_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_ACCEPTED_PROMOTIONS(state, payload) {
            state.acceptedPromotions = payload
        },
        SET_VALIDATION_PRICES_ERRORS(state, payload) {
            state.validationPricesError = payload
        },
        SET_COMPANIES_FOR_PROMO_FILTERS(state, payload) {
            state.companiesForPromoFilters = payload
        },
        SET_PROMO_TYPES_FOR_PROMO_FILTERS(state, payload) {
            state.promoTypesForPromoFilters = payload
        }
    },
    actions: {
        setPromotionsDefaultPerPage({ state, commit }) {
            commit(
                'SET_PROMOTIONS_PER_PAGE',
                state.perPageByRoute[router.currentRoute.name]
            )
        },
        setPromotionsPerPageByRoute({ state, commit }) {
            const tmpPerPageByRoute = state.perPageByRoute

            Object.assign(tmpPerPageByRoute, {
                [router.currentRoute.name]: state.pagination.perPage
            })

            commit('SET_PROMOTIONS_PER_PAGE_BY_ROUTE', tmpPerPageByRoute)
        },
        async setPromoFilterQueryParams({ state, dispatch, getters }, payload) {
            const promoState = payload?.promoState || router.currentRoute.name

            const paramsAdditional = await dispatch(
                'setPromotionsTimeParams',
                state.filters
            )

            if (state.filters.newPromos.value) {
                if (!getters.getDashboard) {
                    await dispatch('dashboardStatsFetch')
                }
                paramsAdditional['promo|id'] =
                    getters.getDashboard && getters.getDashboard.new_promos
                        ? getters.getDashboard.new_promos.join(',')
                        : ''
            }

            const today = moment()
                .utc()
                .format('YYYY-MM-DDTHH:mm:ss[Z]')

            switch (promoState) {
            case 'promo-yours':
                paramsAdditional['promo|state'] = 'active'
                paramsAdditional['promo|subscription|state'] = 'accepted'
                paramsAdditional.sort =
                        'position,subscriptions.status_updated_at'
                paramsAdditional.direction = 'desc,desc'
                break
            case 'promo-later':
                paramsAdditional['promo|state'] = 'active'
                paramsAdditional['promo|subscription|state'] =
                        'available,interrupted'
                paramsAdditional['promo|favourite'] = 'true'
                paramsAdditional.sort = 'position,favourites.created_at'
                paramsAdditional.direction = 'desc,desc'
                paramsAdditional['promo|locked_at'] = `nil,${today}..nil`
                break

            case 'promo-finished':
                // group[1]
                paramsAdditional['_group[1][promo.state]'] =
                        'cancelled,finished'
                paramsAdditional['_group[1][promo.subscription.state]'] =
                        'accepted,available,interrupted,incompatible'

                // // group[2]
                paramsAdditional[
                    '_group[2][promo.subscription.suspended]'
                ] = true
                paramsAdditional['_group[2][promo.subscription.state]'] =
                        'accepted,available,interrupted,incompatible'

                // group[3]
                paramsAdditional['_group[3][promo.state]'] = 'active'
                paramsAdditional['_group[3][promo.subscription.state]'] =
                        'available,interrupted,incompatible'
                paramsAdditional[
                    '_group[3][promo.locked_at]'
                ] = `nil..${today}`

                paramsAdditional.sort = 'finished_at'
                paramsAdditional.direction = 'desc'
                break

            case 'promo-details':
                paramsAdditional['promo|state'] = 'active'
                paramsAdditional['promo|subscription|state'] =
                        'available,interrupted,incompatible'
                break

            default:
                paramsAdditional['promo|locked_at'] = `nil,${today}..nil`
                paramsAdditional['promo|state'] = 'active'
                paramsAdditional['promo|subscription|state'] =
                        'available,interrupted,incompatible'
                paramsAdditional.sort = 'position,published_at'
                paramsAdditional.direction = 'desc,desc'
            }

            if (
                promoState !== 'promo-finished' &&
                promoState !== 'promo-details'
            ) {
                paramsAdditional['promo|subscription|suspended'] = false
            }

            let paramsGroups = await dispatch('setFilterQueryParams', {
                filters: state.filters,
                promoState
            })

            paramsGroups = { ...paramsGroups, ...paramsAdditional }

            // if no merchants selected, add all available merchants
            if (
                state.filters['promo|subscription|merchant_id']?.value.length &&
                promoState !== 'promo-finished' &&
                promoState !== 'promo-details'
            ) {
                const filteredSubscriptionMerchantId = state.filters[
                    'promo|subscription|merchant_id'
                ].value.filter(el =>
                    getters.getAvailableMerchants.map(el => el.id).includes(el)
                )
                paramsGroups[
                    'promo|subscription|merchant_id'
                ] = filteredSubscriptionMerchantId.join()
                state.filters[
                    'promo|subscription|merchant_id'
                ].value = filteredSubscriptionMerchantId
            }

            if (
                !state.filters['promo|subscription|merchant_id']?.value
                    .length &&
                promoState !== 'promo-finished' &&
                promoState !== 'promo-details'
            ) {
                paramsGroups[
                    'promo|subscription|merchant_id'
                ] = getters.getAvailableMerchants.map(el => el.id).join()
            }

            // loyalty
            if (paramsGroups['promo|type']?.includes('loyalty')) {
                const changedPromoTypes = paramsGroups['promo|type'].replace(
                    'loyalty',
                    ''
                )

                paramsGroups['promo|type'] = changedPromoTypes.length
                    ? changedPromoTypes
                    : null
                paramsGroups['promo|loyalty'] = true
            }

            // change query params for promo requests
            const paramsPromos = {}
            for (const [key, value] of Object.entries(paramsGroups)) {
                if (key === 'name' || key.includes('[name]')) continue
                let newKey = key.replace('promo|', '')
                newKey = newKey.replace('promo.', '')
                paramsPromos[newKey] = value
            }

            return {
                paramsGroups,
                paramsPromos
            }
        },
        async setDynamicPromoFilters(
            { state, commit, getters },
            isOnlySetCompanies
        ) {
            const params = {}
            const routeName = router.currentRoute.name

            switch (routeName) {
            case 'promo-yours':
                params.state = 'active'
                params['subscription|state'] = 'accepted'
                break
            case 'promo-later':
                params.state = 'active'
                params['subscription|state'] = 'available,interrupted'
                params.favourite = 'true'
                break
            case 'promo-finished':
                params.state = 'cancelled,finished'
                break
            case 'labels':
                params.state = 'active'
                params['subscription|state'] = 'accepted'
                params.type = getters.getLabelPromoTypes.join(',')
                break
            case 'settlements':
                params.state = 'cancelled,finished'
                break
            default:
                params.state = 'active'
                params['subscription|state'] =
                        'available,interrupted,incompatible'
            }

            params['promo|subscription|merchant_id'] =
                routeName === 'promo-finished'
                    ? getters.getMerchants.map(el => el.id).join(',')
                    : getters.getAvailableMerchants.map(el => el.id).join(',')
            const companyIdAggregateResponse = await this.$api.get(
                'promos/aggregate/count/company_id',
                { params }
            )
            const companiesAvailableIds = Object.keys(
                companyIdAggregateResponse.data.data
            ).map(e => parseInt(e))
            const selectedCompanyIds =
                getters.getPromotionsFilters['promo|company_id'].value
            const activeCompaniesIds = [
                ...companiesAvailableIds,
                ...selectedCompanyIds
            ]
            const companies = getters.getCompaniesForFilters.filter(company => {
                if (activeCompaniesIds.includes(company.value)) return company
            })
            commit('SET_COMPANIES_FOR_PROMO_FILTERS', companies)

            if (!isOnlySetCompanies) {
                const typesAggregateResponse = await this.$api.get(
                    'promos/aggregate/count/type',
                    { params }
                )
                const availableTypes = Object.keys(
                    typesAggregateResponse.data.data
                )
                const selectedTypes =
                    routeName === 'labels'
                        ? getters.getLabelGroupsFilters['promo|type'].value
                        : getters.getPromotionsFilters['promo|type'].value

                const activeTypes = [...availableTypes, ...selectedTypes]

                let enabledPromoTypes
                if (routeName === 'labels') {
                    enabledPromoTypes = getters.getLabelPromoTypes
                }

                const typesForFilters = getters
                    .getPromoTypesForFilters(enabledPromoTypes)
                    .filter(type => {
                        if (activeTypes.includes(type.value)) return type
                    })

                if (routeName === 'labels') {
                    commit('SET_LABEL_PROMO_TYPES_FOR_PROMO_FILTERS', typesForFilters)
                } else {
                    commit('SET_PROMO_TYPES_FOR_PROMO_FILTERS', typesForFilters)
                }
            }
        },
        setScrollY({ commit }, payload) {
            commit('SET_SCROLLY', payload)
        },
        setDefaultSortOption({ state, commit }) {
            commit('SET_PROMOTIONS_SORT', {
                by:
                    state.activeSortOptionByRoute[router.currentRoute.name]
                        .query,
                direction:
                    state.activeSortOptionByRoute[router.currentRoute.name]
                        .direction
            })
        },

        setPromotionsSort({ state, commit, getters }, payload) {
            let routeName = router.currentRoute.name
            if (!routeName) return

            if (routeName === 'link') {
                routeName = getters.getGeneratedLink.url.name
            }

            commit('SET_PROMOTIONS_SORT', payload)

            const sortOption = state.sortOptions.find(
                o => o.query === payload.by
            )
            commit('SET_ACTIVE_SORT_OPTION_BY_ROUTE', {
                routeName,
                sortOption: { ...sortOption, direction: payload.direction }
            })
        },
        selectPromotion({ state, commit, dispatch, getters }, payload) {
            let selectedPromotions = state.selectedPromotions
            const promotionIds = selectedPromotions.map(item => item.id)

            if (promotionIds.includes(payload.id)) {
                selectedPromotions = selectedPromotions.filter(
                    item => item.id !== payload.id
                )
            } else {
                const promotion = state.promotions.find(
                    item => item.id === payload.id
                )

                if (
                    promotion.subscriptions &&
                    promotion.subscriptions.length > 0 &&
                    promotion.subscriptions[0].company_merchant_status ===
                        'inactive'
                ) {
                    promotion.marketingPromoConflict = true
                }

                if (
                    promotion.subscriptions.find(
                        el => el.company_merchant_status === 'active'
                    )
                ) {
                    let products = []
                    let productSets = []
                    let promoSubs = promotion.subscriptions
                    const eans = []

                    if (promotion.products.length > 0) {
                        products = promotion.products
                        products = products.map(item => {
                            eans.push(item.ean)
                            return {
                                productName: item.dict_product.name,
                                productId: item.id,
                                productPrice: null,
                                productMaxPrice: item.maximum_promotional_price
                                    ? item.maximum_promotional_price
                                    : null
                            }
                        })
                    } else if (promotion.product_sets.length > 0) {
                        productSets = promotion.product_sets.map(el => {
                            el.product_set_dict_products.forEach(item => {
                                eans.push(item.ean)
                            })
                            return {
                                id: el.id,
                                price: null,
                                maxPrice: el.price
                            }
                        })
                    }

                    if (promoSubs) {
                        promoSubs = promoSubs
                            .filter(el => el.state === 'available')
                            .filter(
                                el => el.company_merchant_status !== 'inactive'
                            )
                            .map(el => {
                                return {
                                    ...el,
                                    checked: true,
                                    products: products,
                                    product_sets: productSets
                                }
                            })
                    }

                    // push to selected promotions if ean doesnt exists already
                    selectedPromotions.push({
                        ...promotion,
                        subscriptions: promoSubs,
                        subscriptionsEqualPrices: {
                            equalPrices: true,
                            priceGroups: [promoSubs]
                        }
                    })
                }
            }
            if (selectedPromotions.length === 0) {
                dispatch('toggleModal', false)
            }
            this.$storage.setItem('selectedPromotions', selectedPromotions)
            commit('SET_SELECTED_PROMOTIONS', selectedPromotions)
            dispatch('checkPricesErrors')
        },
        setSelectAllPromotions({ commit }, payload) {
            commit('SET_SELECT_ALL_PROMOTIONS', payload)
        },
        setPromotionsPaginationCurrent({ commit }, payload) {
            commit('SET_PROMOTIONS_PAGINATION_CURRENT', payload)
        },
        setPromotionsPerPage({ commit }, payload) {
            commit('SET_PROMOTIONS_PER_PAGE_BY_ROUTE', payload)
        },
        setPromotionsPagination({ commit }, payload) {
            commit('SET_PROMOTIONS_PAGINATION', payload)
        },
        setPromotionsIncludes({ commit }, payload) {
            commit('SET_PROMOTION_INCLUDES', payload)
        },
        resetPromotions({ state, commit }) {
            commit('SET_PROMOTIONS', null)
            const pagination = Object.assign({}, state.pagination)
            pagination.totalRecords = null
            commit('SET_PROMOTIONS_PAGINATION', pagination)
        },
        promotionsFetchFilters({ commit, state }, payload) {
            return this.$api
                .get('promos/', {
                    params: {
                        page: 1,
                        per: 99999,
                        sort: 'name',
                        // eslint-disable-next-line max-len
                        includes: 'company,products,product.dict_product,product_sets,product_set.product_set_dict_products,product_set_dict_product.dict_product',
                        'subscription.state':
                            payload && payload.subscriptionState
                                ? payload.subscriptionState
                                : 'accepted',
                        state:
                            payload && payload.state ? payload.state : 'active',
                        id:
                            payload && payload.promotionIds
                                ? payload.promotionIds
                                : null,
                        name:
                            payload && payload.promotionName
                                ? payload.promotionName
                                : null
                    }
                })
                .then(res => {
                    commit('SET_PROMOTIONS', res.data.data)
                })
        },
        async promotionsFetchForFilters({ commit, state }, payload = {}) {
            try {
                const { data, status } = await this.$api.get('promos', {
                    params: {
                        page: payload.page || 1,
                        per: payload.per || 10,
                        query: payload.query,
                        sort: 'name',
                        includes: '',
                        'subscription.state': payload.subscriptionState || 'accepted',
                        state: payload.state,
                        id: payload.promotionIds
                    }
                })
                if (status !== 200 || !data?.data) {
                    throw new Error(data?.data?.error || 'Error promotionsFetchForFilters')
                }
                const promos = data.data.map(promo => ({
                    value: promo.id,
                    label: promo.name
                }))
                if (payload?.page !== 1) {
                    const newPromos = [...state.promotionsForFilters]
                    commit('SET_PROMOTIONS_FOR_FILTERS', [
                        ...newPromos,
                        ...promos
                    ])
                } else {
                    commit('SET_PROMOTIONS_FOR_FILTERS', promos)
                }
            } catch (err) {
                console.error(err)
            }
        },
        async promotionsFetch({ state, commit, getters, dispatch }, payload) {
            if (getters.getWalkthroughActive) {
                commit('SET_PROMOTIONS_PAGINATION', {
                    page: 1,
                    totalPages: 0,
                    perPage: 10,
                    totalRecords: null
                })
                return
            }
            if (getters.isLotteryUser) {
                commit('SET_PROMOTIONS', lotteryPromotions)
                commit('SET_PROMOTIONS_PAGINATION', {
                    page: 1,
                    totalPages: 0,
                    perPage: 10,
                    totalRecords: null
                })
                return
            }

            commit('SET_PROMOTIONS_STATUS', 'loading')

            if (router.currentRoute.query.page) {
                commit(
                    'SET_PROMOTIONS_PAGINATION_CURRENT',
                    +router.currentRoute.query.page
                )
            }

            const perPageByRoute =
                state.perPageByRoute[router.currentRoute.name]

            if (perPageByRoute) {
                commit('SET_PROMOTIONS_PER_PAGE', perPageByRoute)
            }

            if (router.currentRoute.query.show) {
                commit(
                    'SET_PROMOTIONS_PER_PAGE',
                    +router.currentRoute.query.show
                )
            }

            dispatch('setPromotionsPerPageByRoute')

            dispatch('saveLocalForagePagination', {
                promotions: state.perPageByRoute
            })

            const { paramsPromos: params } = await dispatch(
                'setPromoFilterQueryParams'
            )

            const routeName = router.currentRoute.name
            return this.$api
                .get(`promos/?${params}`, {
                    params: {
                        page: state.pagination.page,
                        per:
                            payload && payload.fetchAll
                                ? null
                                : state.pagination.perPage,
                        includes: state.promotionsIncludes
                    }
                })
                .then(response => {
                    // prevent from overwrite data from from other tab
                    if (routeName !== router.currentRoute.name) return

                    const responseData = response.data.data
                    const paging = {
                        perPage: +response.data.pagination[0].perPage,
                        page: +response.data.pagination[0].page,
                        totalPages: +response.data.pagination[0].totalPages,
                        totalRecords: +response.data.pagination[0].totalRecords
                    }

                    if (
                        response &&
                        paging.totalRecords > 0 &&
                        paging.page <= paging.totalPages
                    ) {
                        const promoIds = responseData
                            .map(item => {
                                return item.id
                            })
                            .join(',')

                        let subStatusQuery = ''
                        if (
                            state.subscriptionsSearchQuery.split(
                                'subscription|state='
                            )[1]
                        ) {
                            subStatusQuery = `&state=${
                                state.subscriptionsSearchQuery.split(
                                    'subscription|state='
                                )[1]
                            }`
                        }

                        return this.$api
                            .get(
                                `subscriptions?promo_id=${promoIds}${subStatusQuery}`,
                                {
                                    params: {
                                        per: 999999
                                    }
                                }
                            )
                            .then(res => {
                                const filteredSub = res.data.data
                                    .map(sub => {
                                        return {
                                            subId: sub.id,
                                            merchant_id: sub.merchant_id,
                                            id: sub.promo_id,
                                            state: sub.state,
                                            updated_at: sub.updated_at,
                                            company_merchant_status:
                                                sub.company_merchant_status
                                        }
                                    })
                                    .reduce(
                                        (h, sub) =>
                                            Object.assign(h, {
                                                [sub.id]: (
                                                    h[sub.id] || []
                                                ).concat({
                                                    id: sub.subId,
                                                    merchant_id:
                                                        sub.merchant_id,
                                                    state: sub.state,
                                                    updated_at: sub.updated_at,
                                                    company_merchant_status:
                                                        sub.company_merchant_status
                                                })
                                            }),
                                        {}
                                    )

                                const merged = responseData.map(item =>
                                    Object.assign(
                                        {},
                                        item,
                                        { marketingPromoConflict: false },
                                        { subscriptions: filteredSub[item.id] },
                                        {
                                            subscriptionsEqualPrices: {
                                                equalPrices: false,
                                                priceGroups: [
                                                    filteredSub[item.id]
                                                ]
                                            }
                                        }
                                    )
                                )
                                commit('SET_PROMOTIONS_PAGINATION', paging)
                                commit('SET_PROMOTIONS', merged)
                                commit('SET_PROMOTIONS_STATUS', 'idle')
                                commit('SET_SELECT_ALL_PROMOTIONS', false)
                            })
                    } else {
                        commit('SET_PROMOTIONS', [])
                        if (
                            paging.totalRecords === 0 &&
                            !(payload && payload.fetchAll)
                        ) {
                            commit('SET_PROMOTIONS_PAGINATION', paging)
                        }
                        commit('SET_PROMOTIONS_PAGINATION_CURRENT', 1)
                        commit('SET_PROMOTIONS_STATUS', 'idle')
                    }
                })
                .catch(err => {
                    if (!this.$api.isCancel(err)) {
                        commit('SET_PROMOTIONS_STATUS', 'idle')
                        commit('SET_SELECT_ALL_PROMOTIONS', false)
                    }
                })
        },
        setSubscriptionsSearchQuery({ commit }) {
            let subscriptionsSearchQuery = null
            if (
                router.currentRoute.name === 'promo-list' ||
                router.currentRoute.name === 'promo-yours' ||
                router.currentRoute.name === 'promo-later'
            ) {
                subscriptionsSearchQuery = {
                    state: 'accepted,available,interrupted,incompatible'
                }
            }
            commit('SET_SUBSCRIPTIONS_SEARCH_QUERY', subscriptionsSearchQuery)
        },
        loadSelectedPromotions({ commit }) {
            return this.$storage.getItem('selectedPromotions').then(res => {
                if (res) {
                    commit('SET_SELECTED_PROMOTIONS', res)
                }
            })
        },
        setAcceptedPromotions({ commit }, payload) {
            commit('SET_ACCEPTED_PROMOTIONS', payload)
        },
        checkPricesErrors({ state, commit, getters }) {
            const selectedGroups = getters.getSelectedPromoGroups

            selectedGroups.forEach(group => {
                let errors = false
                const selectedPromos = group.promos.filter(
                    promo => promo.selected
                )

                const subscriptions = []
                selectedPromos.forEach(promo => {
                    if (
                        promo.subscriptionsEqualPrices &&
                        promo.subscriptionsEqualPrices.equalPrices &&
                        promo.subscriptionsEqualPrices.priceGroups.length
                    ) {
                        promo.subscriptionsEqualPrices.priceGroups.forEach(
                            group => {
                                group.forEach(sub => {
                                    if (sub.checked) {
                                        subscriptions.push({
                                            ...sub,
                                            promo_id: promo.id
                                        })
                                    }
                                })
                            }
                        )
                    } else {
                        promo.subscriptions.forEach(sub => {
                            subscriptions.push({
                                ...sub,
                                promo_id: promo.id
                            })
                        })
                    }
                })

                subscriptions.forEach(el => {
                    if (el.checked) {
                        if (el.products && el.products.length > 0) {
                            el.products.forEach(el => {
                                if (
                                    +el.productPrice > +el.productMaxPrice ||
                                    el.productPrice === '0' ||
                                    el.productPrice === '0.00' ||
                                    el.productPrice === 0
                                ) {
                                    errors = true
                                }
                            })
                        }
                        if (el.product_sets && el.product_sets.length > 0) {
                            el.product_sets.forEach(el => {
                                if (
                                    (el.price && +el.price > +el.maxPrice) ||
                                    el.price === '0' ||
                                    el.price === '0.00' ||
                                    el.price === 0
                                ) {
                                    errors = true
                                }
                            })
                        }
                    }
                })
                commit('SET_VALIDATION_PRICES_ERRORS', errors)
            })
        },
        clearSelectedPromotions({ commit }) {
            commit('SET_SELECTED_PROMOTIONS', [])
            this.$storage.setItem('selectedPromotions', [])
        },
        setPromotionsFilters({ state, commit, getters }) {
            if (getters.isLotteryUser) {
                const tmpFilters = Object.assign({}, state.filters)
                Object.entries(tmpFilters).forEach(entry => {
                    entry[1].inactive = true
                })
                commit('RESET_PROMOTIONS_FILTERS', tmpFilters)
            }
        },
        setPromotionEqualPrice({ state, commit, getters }, payload) {
            const { previewType } = payload

            let promoGroups = null
            // let nonSelectedPromo = null

            if (previewType === 'labels') {
                promoGroups = JSON.parse(
                    JSON.stringify(getters.getSelectedLabelGroups)
                )
                // nonSelectedPromo = getters.getLabelGroups
                //     .find(el => el.id === payload.groupId)
                //     ?.promos?.find(el => el.id === payload.promoId)
            } else {
                promoGroups = JSON.parse(
                    JSON.stringify(getters.getSelectedPromoGroups)
                )
                // nonSelectedPromo = getters.getPromoGroups
                //     .find(el => el.id === payload.groupId)
                //     ?.promos?.find(el => el.id === payload.promoId)
            }

            const promoGroup = promoGroups.find(
                group => group.id === payload.groupId
            )
            const selectedPromos = promoGroup.promos
            const findPromo = selectedPromos.find(
                el => el.id === payload.promoId
            )

            findPromo.subscriptionsEqualPrices.equalPrices = payload.val

            // if (nonSelectedPromo) {
            //     nonSelectedPromo.subscriptions = findPromo.subscriptions
            //     nonSelectedPromo.subscriptionsEqualPrices =
            //         findPromo.subscriptionsEqualPrices
            // }

            if (previewType === 'labels') {
                commit('SET_SELECTED_LABELGROUPS', promoGroups)
            } else {
                commit('SELECT_PROMOGROUP', promoGroups)
            }
        },
        setPromotionEqualLocalCodes({ state, commit, getters }, payload) {
            const { val, promoId, groupId } = payload

            const group = getters.getPromoGroups.find(g => g.id === groupId)
            if (group) {
                const promo = group.promos.find(p => p.id === promoId)
                if (promo) {
                    promo.equalLocalCodes = val
                    // commit('SET_PROMOGROUPS', groups)
                }
            }

            const sGroups = JSON.parse(
                JSON.stringify(getters.getSelectedPromoGroups)
            )
            const sGroup = sGroups.find(g => g.id === groupId)
            const sPromo = sGroup.promos.find(p => p.id === promoId)
            sPromo.equalLocalCodes = val
            commit('SELECT_PROMOGROUP', sGroups)
            return true
        },
        addPriceGroup({ state, commit, getters }, payload) {
            const { previewType } = payload

            let promoGroups = null
            if (previewType === 'labels') {
                promoGroups = JSON.parse(
                    JSON.stringify(getters.getSelectedLabelGroups)
                )
            } else {
                promoGroups = JSON.parse(
                    JSON.stringify(getters.getSelectedPromoGroups)
                )
            }

            const promoGroup = promoGroups.find(
                group => group.id === payload.groupId
            )
            const selectedPromos = promoGroup.promos

            const findPromo = selectedPromos.find(
                el => el.id === payload.promoId
            )
            const priceGroups = findPromo.subscriptionsEqualPrices.priceGroups
            const lastPriceGroup = priceGroups[priceGroups.length - 1]
            const newPriceGroup = lastPriceGroup.filter(el => !el.checked)
            findPromo.subscriptionsEqualPrices.priceGroups.push(
                JSON.parse(JSON.stringify(newPriceGroup))
            )

            if (previewType === 'labels') {
                commit('SET_SELECTED_LABELGROUPS', promoGroups)
            } else {
                commit('SELECT_PROMOGROUP', promoGroups)
            }
        },
        recreatePriceGroups({ state, commit, dispatch, getters }, payload) {
            const { previewType } = payload
            let promoGroups = null

            if (previewType === 'labels') {
                promoGroups = JSON.parse(
                    JSON.stringify(getters.getSelectedLabelGroups)
                )
            } else {
                promoGroups = JSON.parse(
                    JSON.stringify(getters.getSelectedPromoGroups)
                )
            }

            const promoGroup = promoGroups.find(
                group => group.id === payload.groupId
            )
            const selectedPromos = promoGroup.promos
            const findPromo = selectedPromos.find(
                el => el.id === payload.promoId
            )
            const priceGroups = findPromo.subscriptionsEqualPrices.priceGroups
            const newPriceGroups = [priceGroups[0]]
            for (let i = 1; i <= priceGroups.length; i++) {
                if (priceGroups[i]) {
                    const lastPriceGroup = priceGroups[i - 1]
                    let newPriceGroup = lastPriceGroup.filter(el => !el.checked)
                    newPriceGroup = newPriceGroup.map(el => {
                        const oldSub = priceGroups[i].find(
                            elem => elem.id === el.id
                        )
                        if (oldSub && el.id === oldSub.id) {
                            return oldSub
                        } else {
                            if (priceGroups[i][0]) {
                                el.products = priceGroups[i][0].products
                                el.product_sets = priceGroups[i][0].product_sets
                            }
                            return el
                        }
                    })
                    if (newPriceGroup.length) {
                        newPriceGroups.push(
                            JSON.parse(JSON.stringify(newPriceGroup))
                        )
                    }
                }
            }
            findPromo.subscriptionsEqualPrices.priceGroups = newPriceGroups

            if (previewType === 'labels') {
                commit('SET_SELECTED_LABELGROUPS', promoGroups)
            } else {
                commit('SELECT_PROMOGROUP', promoGroups)
            }
        },
        async removePriceGroup({ commit, dispatch, getters }, payload) {
            const { previewType } = payload

            let promoGroups = null
            if (previewType === 'labels') {
                promoGroups = JSON.parse(
                    JSON.stringify(getters.getSelectedLabelGroups)
                )
            } else {
                promoGroups = JSON.parse(
                    JSON.stringify(getters.getSelectedPromoGroups)
                )
            }

            const promoGroup = promoGroups.find(
                group => group.id === payload.groupId
            )
            const selectedPromos = promoGroup.promos

            const searchedPromotion = selectedPromos.find(
                el => el.id === payload.promoId
            )

            const priceGroups =
                searchedPromotion.subscriptionsEqualPrices.priceGroups
            priceGroups.splice(payload.groupIdx, 1)

            if (previewType === 'labels') {
                commit('SET_SELECTED_LABELGROUPS', promoGroups)
            } else {
                commit('SELECT_PROMOGROUP', promoGroups)
            }

            dispatch('recreatePriceGroups', {
                promoId: payload.promoId,
                groupId: payload.groupId,
                previewType
            })
            dispatch('checkPricesErrors')
        },
        setPromotionsTimeParams(_, payload) {
            const filters = payload
            const params = {}
            const currentRoute = router.currentRoute.name
            const today = Vue.moment().format('DD-MM-YYYYTHH:mm:ss')

            if (
                filters.endingPromos.value &&
                currentRoute !== 'promo-finished'
            ) {
                const future = Vue.moment()
                    .add(7, 'days')
                    .format('DD-MM-YYYYTHH:mm:ss')
                params['promo|end_at'] = `${today}Z,${future}Z`
            }

            if (
                filters.activePromos.value &&
                currentRoute !== 'promo-finished'
            ) {
                const past = Vue.moment()
                    .subtract(100, 'years')
                    .format('DD-MM-YYYYTHH:mm:ss')
                const future = Vue.moment()
                    .add(100, 'years')
                    .format('DD-MM-YYYYTHH:mm:ss')
                params['promo|start_at'] = `${past}Z,${today}Z`
                params['promo|end_at'] = `${today}Z,${future}Z`
            }

            if (
                filters.startingPromos.value &&
                currentRoute !== 'promo-finished'
            ) {
                const future = Vue.moment()
                    .add(7, 'days')
                    .format('DD-MM-YYYYTHH:mm:ss')
                params['promo|start_at'] = `${today}Z,${future}Z`
            }
            return params
        }
    },
    getters: {
        getPromoTypesForPromoFilters: (state, getters) => {
            const promoTypes = state.promoTypesForPromoFilters.map(t => {
                if (t.value === 'Promo::Bonded') {
                    t.value = getters.getBondedTypes.join(',')
                }
                return t
            })
            return [
                { label: 'Tylko z aplikacją', value: 'loyalty' },
                ...promoTypes
            ]
        },
        getCompaniesForPromoFilters: state => state.companiesForPromoFilters,
        getPromotionsSearchQuery: state => state.promotionsSearchQuery,
        getSubscriptionsSearchQuery: state => state.subscriptionsSearchQuery,
        promotions: state => {
            if (state.promotions) {
                return state.promotions
            }
        },
        getPromotionsStatus: state => {
            return state.status
        },
        getPromotionsForFilters: state => {
            return state.promotionsForFilters
        },
        getPromotionsPagination: state => {
            return state.pagination
        },
        getSelectedPromotionBoolean: state => id => {
            if (state.selectedPromotions) {
                if (state.selectedPromotions.find(item => item.id === id)) {
                    return true
                } else {
                    return false
                }
            }
        },
        getSelectedPromotion: state => id => {
            if (state.selectedPromotions) {
                return state.selectedPromotions.find(item => item.id === id)
            }
        },
        getPromotionShops: (state, getters) => payload => {
            const promo = getters.getSelectedPromoGroupPromoItem(payload)
            return promo?.subscriptions?.filter(el => el.state === 'available')
        },
        getPromotionShopsEP: (state, getters) => payload => {
            const promo = getters.getSelectedPromoGroupPromoItem(payload)
            const priceGroups = promo.subscriptionsEqualPrices.priceGroups.map(
                pg => {
                    return pg.filter(el => el.state === 'available')
                }
            )
            return priceGroups
        },
        getPromotionById: state => id => {
            if (state.promotions) {
                return state.promotions.find(item => item.id === id)
            }
        },
        getSelectedShops: state => id => {
            if (state.selectedPromotions) {
                let subscriptions = state.selectedPromotions.find(
                    item => item.id === id
                ).subscriptions
                if (subscriptions) {
                    subscriptions = subscriptions.filter(el => {
                        return el !== undefined && el.checked === true
                    })
                    return subscriptions
                }
            }
        },
        getPromotionsSelectAll: state => {
            return state.selectAll
        },
        getPromotionsSortOptions: state => route => {
            let sortOptions = state.sortOptions.map(e => Object.assign(e))

            if (route !== 'promo-list') {
                sortOptions = sortOptions.filter(
                    el => el.query !== 'published_at'
                )
            }
            if (route !== 'promo-later') {
                sortOptions = sortOptions.filter(
                    el => el.query !== 'favourites.created_at'
                )
            }
            if (route !== 'promo-yours') {
                sortOptions = sortOptions.filter(
                    el => el.query !== 'subscriptions.status_updated_at'
                )
            }
            if (route !== 'promo-finished') {
                sortOptions = sortOptions.filter(
                    el => el.query !== 'finished_at'
                )
            }
            if (route === 'promo-finished') {
                sortOptions = sortOptions.filter(
                    el => el.query !== 'start_at' && el.query !== 'end_at'
                )
            }

            return sortOptions
        },
        getPromotionsActiveSortOptionByRoute: state => route => {
            const activeSortOptionName = state.activeSortOptionByRoute[route]
                ? state.activeSortOptionByRoute[route].label
                : ''
            return activeSortOptionName
        },
        getPromotionsSort: state => {
            return state.sort
        },
        getScrollY: state => {
            return state.scrollY
        },
        getPromotionsFiltersByRoute: state => route => {
            state.filters['promo|subscription|merchant_id'].getter =
                route === 'promo-finished'
                    ? 'getPromoAllMerchantsForSelect'
                    : 'getPromoMerchantsForSelect'
            state.filters['promo|subscription|merchant|nip'].getter =
                route === 'promo-finished'
                    ? 'getUserAllCompaniesForSelect'
                    : 'getUserCompaniesForSelect'
            if (route === 'promo-finished') {
                const {
                    endingPromos,
                    activePromos,
                    startingPromos,
                    ...filters
                } = state.filters
                return filters
            } else {
                return state.filters
            }
        },
        getPromotionsFilters: state => {
            return state.filters
        },
        getStatusTypesForSelect: () => {
            const statuses = [
                {
                    value: 'finished',
                    label: 'Zakończona'
                },
                {
                    value: 'active',
                    label: 'Aktywna'
                },
                {
                    value: 'cancelled',
                    label: 'Anulowana'
                }
            ]
            return statuses
        },
        getAcceptedPromotions: state => {
            return state.acceptedPromotions
        },
        getPriceErrors: state => {
            return state.validationPricesError
        },
        atLeastOneOfSelectedPromotionsHasNoSubsActive: (
            state,
            getters
        ) => payload => {
            const { promotion, state } = payload
            let noGroupSelected = false
            let noSubsSelected = false
            const promoGroups = promotion
                ? [promotion]
                : getters.getSelectedPromoGroups

            const checkPromosSelectedSubs = promo => {
                const subs = getters.getSubscriptionsByPromo(promo)
                    .filter(el => el.state !== 'deleted')

                if (state === 'interrupted') {
                    const filteredSubs = subs.filter(s => s.state === state)

                    if (filteredSubs.length === subs.length) {
                        noSubsSelected = true
                        return true
                    }
                } else if (subs.every(sub => sub.checked === false)) {
                    noSubsSelected = true
                    return true
                }
            }

            if (promotion) {
                return checkPromosSelectedSubs(promotion)
            } else {
                promoGroups.forEach(group => {
                    let promoHasUnselectedSub = false
                    const allGroupPromosAreSelected =
                        +group.pagination.totalRecords ===
                        group.promos.filter(promo => promo.selected).length

                    group.promos
                        .filter(promo => promo.selected)
                        .forEach(promo => {
                            const hasAnyPromoUnselectedSubs = checkPromosSelectedSubs(
                                promo
                            )
                            if (hasAnyPromoUnselectedSubs) {
                                promoHasUnselectedSub = true
                            }
                        })

                    if (
                        (promoHasUnselectedSub || group.selectWholeGroup) &&
                        !allGroupPromosAreSelected
                    ) {
                        const merchantInactive = group.merchantIds?.every(
                            merchant => !merchant.selected
                        )
                        if (merchantInactive) noGroupSelected = true
                    }
                })
                return noSubsSelected || noGroupSelected
            }
        },
        getPromoMerchantsForSelect: (state, getters) => {
            return getters.getMerchantsForSelect.map(el => {
                const selectedNips =
                    state.filters['promo|subscription|merchant|nip'].value
                const isDisabled = !!(
                    selectedNips.length &&
                    !selectedNips.includes(el.nip.toString())
                )
                const tooltip = isDisabled
                    ? 'Filtr niedostępny: sklep nie należy do wybranego NIPu'
                    : undefined

                return {
                    label: el.label,
                    value: el.value,
                    disabled: isDisabled,
                    tooltip
                }
            })
        },
        getPromoAllMerchantsForSelect: (state, getters) => {
            return getters.getAllMerchantsForSelect.map(el => {
                const selectedNips =
                    state.filters['promo|subscription|merchant|nip'].value
                const isDisabled = !!(
                    selectedNips.length &&
                    !selectedNips.includes(el.nip.toString())
                )
                const tooltip = isDisabled
                    ? 'Filtr niedostępny: sklep nie należy do wybranego NIPu'
                    : undefined

                return {
                    label: el.label,
                    value: el.value,
                    disabled: isDisabled,
                    tooltip
                }
            })
        }
    }
}
